import React, { useState, useEffect } from "react";
import "./VerificationCode.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
import Verification from "../../Components/Verification/Verification";
import Axios from "axios";
import { useAuth } from "../../AuthContext";
import Alert from "../../Components/Alert/Alert";
import { useBaseUrl } from "../../ApiContext";

export default function VerificationCode() {
  const { setUserToken } = useAuth();
  const baseUrl = useBaseUrl();
  const navigate = useNavigate();
  const [isComplete, setIsComplete] = useState(false);
  const [resendCode, setResendCode] = useState(false);
  const [cookie, setCookie] = useCookies(["token"]);
  const location = useLocation();
  const userNumber = location.state?.mobileNumber;
  const wait = location.state?.wait;
  const [minutes, setMinutes] = useState(Math.floor(wait / 60));
  const [seconds, setSeconds] = useState(wait - minutes * 60);
  const [showAlert, setShowAlert] = useState(false);
  const [verificationCode, setVerificationCode] = useState(null);
  const [alertText, setAlertText] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds, minutes]);

  const changeNumber = () => {
    navigate(-1);
  };

  const isCompleteHandler = (code) => {
    setIsComplete(true);
    setVerificationCode(code);
  };

  const openDashboardHandler = () => {
    sendVerificationRequest(verificationCode);
  };

  const sendVerificationRequest = async (code) => {
    try {
      const response = await Axios.post(`${baseUrl}/verify_number`, {
        username: `09${userNumber.replace(/\s/g, "")}`,
        authentication_code: code,
      });
      setUserToken(response.data.token);
      const threeMonthsInMilliseconds = 90 * 24 * 60 * 60 * 1000;
      setCookie("token", response.data.token, {
        path: "/",
        maxAge: threeMonthsInMilliseconds / 1000,
      });
      localStorage.setItem("token", response.data.token);
      navigate("/welcome");
      localStorage.removeItem("goal");
      localStorage.removeItem("age");
      localStorage.removeItem("activity");
      localStorage.removeItem("height");
      localStorage.removeItem("weight");
    } catch (error) {
      console.error("Verification error:", error);
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
      setAlertText("خطا در برقراری ارتباط");
    }
  };
  const resendHandler = async () => {
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 2000);
    setAlertText("در حال ارسال مجدد کد...");
    try {
      const response = await Axios.post(`${baseUrl}/check_number`, {
        username: `09${userNumber.replace(/\s/g, "")}`,
        first_name: "",
        last_name: "",
        latin_name: "",
      });
      console.log(response.data);
      setResendCode(true);
    } catch (error) {
      console.log("Error during resend code", error);
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
      setAlertText("خطا در برقراری ارتباط");
    }
  };
  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="verificationCodeWrapper centeredFlex">
          <div className="verificationCodeTop">
            <h3>کد فعال‌سازی را وارد کنید.</h3>
            <p>
              کد 5 رقمی ارسال شده به شماره{" "}
              {userNumber && <span dir="ltr">{`09${userNumber}`}</span>} را وارد
              کنید.
            </p>
            <Verification
              isComplete={isComplete}
              onComplete={(code) => isCompleteHandler(code)}
            />
          </div>
          <div className="verificationCodeBottom centeredFlex">
            <button
              className="verificationCodeBtn mainBtn"
              onClick={openDashboardHandler}
              style={
                isComplete
                  ? { visibility: "visible" }
                  : { visibility: "hidden" }
              }
            >
              تایید
            </button>
            <div className="verificationCodeActions centeredFlex">
              <span onClick={changeNumber} className="changeNumber">
                تغییر شماره همراه
              </span>
              {seconds > 0 || minutes > 0 ? (
                <span className="resend">
                  ارسال مجدد ({seconds < 10 ? `0${seconds}` : seconds} : 0
                  {minutes})
                </span>
              ) : (
                <span className="resend pointer" onClick={resendHandler}>
                  {resendCode ? "ارسال شد" : "ارسال مجدد"}
                </span>
              )}
            </div>
          </div>
        </div>
        <Alert showAlert={showAlert} alertText={alertText} bottom="6.5rem" />
      </div>
    </div>
  );
}
